module.exports = __webpack_public_path__ + "img/1x.ff7aee6.jpg";